import { createSelector } from '@reduxjs/toolkit';

import { ComponentDesign } from '@paragon/contract-library';

import { RootState } from '..';
import { InsertingComponentDesignInfo } from '../slices/applicationSlice';

const getComponentDesigns = (state: RootState) => state.componentDesigns.data;
export const getInsertingObjectInfo = (state: RootState) => state.application.insertingObjectInfo;

export const isInsertingAnyObject = (state: RootState) => state.application.insertingObjectInfo != null;

export function getComponentDesignInsertionInfoOrNull(state: RootState): InsertingComponentDesignInfo | null {
  const { insertingObjectInfo } = state.application;
  return insertingObjectInfo?.type === 'componentDesign' ? insertingObjectInfo : null;
}

export function getLoadedInsertingComponentDesignInfo(state: RootState) {
  const componentDesignInsertionInfo = getComponentDesignInsertionInfoOrNull(state);
  return componentDesignInsertionInfo?.loadedInfo.isLoaded ? componentDesignInsertionInfo : null;
}

export const getComponentDesignBeingInserted = createSelector(
  getComponentDesigns,
  getLoadedInsertingComponentDesignInfo,
  (componentDesigns, insertingObjectInfo): ComponentDesign | undefined => {
    if (insertingObjectInfo) {
      const { loadedInfo } = insertingObjectInfo;

      if (loadedInfo.isLoaded) {
        return componentDesigns[loadedInfo.guid];
      }
    }
    return undefined;
  },
);
